var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20.0001L4.225 18.5251C3.69167 17.3251 3.3 16.2334 3.05 15.2501C2.8 14.2668 2.61667 13.0751 2.5 11.6751L1.4 12.4001C1.11667 12.5834 0.896 12.8251 0.738 13.1251C0.579333 13.4251 0.5 13.7418 0.5 14.0751V20.0001ZM5.725 18.0001H11.275C11.8583 16.8668 12.2917 15.6874 12.575 14.4621C12.8583 13.2374 13 11.9751 13 10.6751C13 8.59177 12.5873 6.6291 11.762 4.7871C10.9373 2.94576 9.85 1.5501 8.5 0.600098C7.15 1.5501 6.06267 2.94576 5.238 4.7871C4.41267 6.6291 4 8.59177 4 10.6751C4 11.9918 4.14167 13.2668 4.425 14.5001C4.70833 15.7334 5.14167 16.9001 5.725 18.0001ZM8.5 11.0001C7.95 11.0001 7.47933 10.8041 7.088 10.4121C6.696 10.0208 6.5 9.5501 6.5 9.0001C6.5 8.4501 6.696 7.9791 7.088 7.5871C7.47933 7.19576 7.95 7.0001 8.5 7.0001C9.05 7.0001 9.521 7.19576 9.913 7.5871C10.3043 7.9791 10.5 8.4501 10.5 9.0001C10.5 9.5501 10.3043 10.0208 9.913 10.4121C9.521 10.8041 9.05 11.0001 8.5 11.0001ZM16.5 20.0001V14.0751C16.5 13.7418 16.421 13.4251 16.263 13.1251C16.1043 12.8251 15.8833 12.5834 15.6 12.4001L14.5 11.6751C14.3833 13.0751 14.2 14.2668 13.95 15.2501C13.7 16.2334 13.3083 17.3251 12.775 18.5251L16.5 20.0001Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/VectorIcon.485d66bdcfc1b94c1cd22f1ed602340a.svg";
export { ForwardRef as ReactComponent };